import React from "react";
import { cn } from "~/utils";
import { parseName } from "~/utils/parsers";

const Unit = ({ unit, onSelect }) => {
  const { cuid, disabled = false, name = "", tag = "" } = unit;

  const isDisabled = disabled || !onSelect;

  return (
    <div
      className={cn(
        "group ml-1.5 flex items-center justify-between gap-4 rounded-lg p-1.5",
        isDisabled ? "" : "cursor-pointer hover:bg-slate-100",
      )}
      onClick={() => {
        if (!isDisabled) {
          onSelect(unit);
        }
      }}
    >
      <span
        className={cn(
          "text-sm font-semibold",
          isDisabled
            ? "text-gray-400"
            : " text-blue-500 transition group-hover:text-blue-600",
        )}
      >
        {parseName(name)}
      </span>
      {tag && (
        <span
          className={cn(
            "flex-none text-xs text-gray-400 transition",
            isDisabled ? "" : "group-hover:text-gray-500",
          )}
        >
          {tag}
        </span>
      )}
    </div>
  );
};

export default Unit;
